import {
  CartList,
  Mypage,
  MypageEdit,
  OrderComplete,
  OrderConfirm,
  OrderHistory,
  ProductDetail,
  ProductEdit,
  ResetPass,
  SignIn,
  SignUp,
} from "./templates";
import {Auth} from "./Auth";
import {useEffect, useState} from "react";
import {onAuthStateChanged} from "firebase/auth";
import {useDispatch, useSelector} from "react-redux";
import {getRole} from "./reducks/users/selectors";
import {RootState} from "./reducks/store/store";

import {auth} from "./firebase";
import {Route, Routes, useNavigate} from "react-router-dom";
import Maintenance from "./templates/Maintenance";
import {selectAppInfo} from "./reducks/info/selectors";
import {fetchAppInfo} from "./reducks/info/thunks";
import HomePage from "./templates/HomePage";
import SortingPage from "./templates/SortingPage";
import TermsOfService from "./templates/TermsOfService";
import PrivacyPolicy from "./templates/PrivacyPolicy";

var isSignedIn = false;

export const Router = () => {
  /** ログイン状態でサインイン/サインアップ/リセットパスワードのページにいた時にトップに遷移させる．（<Auth>とやり方を合わせるべきであり実装方法としては好ましくない．合わせようとしたが上手くできなかった） */
  // ログイン状態のチェック
  const [signInCheck, setSignInCheck] = useState(false);
  const selector = useSelector((state: RootState) => state);  
  const dispatch = useDispatch();
  const appInfo = useSelector(selectAppInfo);
  const navigate = useNavigate();
  const role = getRole(selector);
  
  useEffect(() => {
    if (appInfo.status === 'idle') dispatch(fetchAppInfo());
  }, [dispatch, appInfo.status]);

  onAuthStateChanged(auth, (user: any) => {
    if (user) {
      isSignedIn = true;
    } else {
      isSignedIn = false;
    }
    setSignInCheck(true);
  });

  // それぞれのページのリンクの正規表現
  const signInRegex = /.+(signin|SignIn|Signin|signIn)/;
  const signUpRegex = /.+(signup|SignUp|Signup|signUp)/;
  const resetPasswordRegex =
    /.+(resetpassword|ResetPassword|Resetpassword|resetPassword)/;
  const maintenanceRegex = /.maintenance/;

  // それぞれのページに居るかどうかを表す変数．bool
  const inSignInPage = signInRegex.test(window.location.href);
  const inSignUpPage = signUpRegex.test(window.location.href);
  const inResetPasswordPage = resetPasswordRegex.test(window.location.href);
  const inMaintenancePage = maintenanceRegex.test(window.location.href);
  
  useEffect(() => {
    // ログイン状態でサインイン/サインアップ/パスワードリセットのページにいた場合は強制的にトップに飛ばす
    if (
      signInCheck &&
      isSignedIn &&
      (inSignInPage || inSignUpPage || inResetPasswordPage)
    ) {
      navigate("/");
    }
    if(appInfo.data?.is_maintenance && !inMaintenancePage){
      navigate("/maintenance");
    }
    if(!appInfo.data?.is_maintenance && inMaintenancePage){
      navigate("/");
    }
  },[signInCheck, inSignInPage, inSignUpPage, inResetPasswordPage, appInfo, inMaintenancePage, navigate]);

  return (
    <Routes>
      <Route path={"/signup"} element={<SignUp/>} />
      <Route path={"/signin"} element={<SignIn/>} />
      <Route path={"/signin/resetPassword"} element={<ResetPass/>} />
      <Route path={"/maintenance"} element={<Maintenance/>} />
      <Route path={"/terms-of-service"} element={<TermsOfService/>} />
      <Route path={"/privacy-policy"} element={<PrivacyPolicy/>} />
      <Route path={"/*"} element={
        // 認証が必要なページをAuthコンポーネントで囲んで監視 
        <Auth roles={['customer', 'admin']}>
          <Routes>
            <Route path={"/"} element={<HomePage/>} />
            <Route path="/product/detail/:id" element={<ProductDetail />} />
            {role === "admin" && (
              <>
                <Route path="/product/edit/:id" element={<ProductEdit />} />
                <Route path="/product/edit" element={<ProductEdit />} />
              </>
            )}
            <Route path={"/cart"} element={<CartList />} />
            <Route path={"/order/confirm"} element={<OrderConfirm />} />
            <Route path={"/order/complete"} element={<OrderComplete />} />
            <Route path={"/order/history"} element={<OrderHistory />} />
            <Route path={"/order/history/:page"} element={<OrderHistory />} />
            <Route path={"/user/my-page"} element={<Mypage />} />
            <Route path={"/user/my-page/edit"} element={<MypageEdit />} />
            <Route path={"/admin/*"} element={
              <Auth roles={['admin']}>
                <Routes>
                  <Route path={"/sort"} element={<SortingPage/>}/>
                </Routes>
              </Auth>
            }/>
          </Routes>
        </Auth>
      }/>
    </Routes>
  );
};
